module.exports = __webpack_public_path__ + "static/media/icon_arrow_down_black.4a80f7bc.svg";